
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface PublicModel {
  id: string;
  display_name: string;
  description: string | null;
  category: string;
  supported_sizes: string[];
  supported_qualities: string[];
}

export const usePublicModels = () => {
  const [models, setModels] = useState<PublicModel[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchModels = async () => {
      try {
        const { data, error } = await supabase
          .from('model_configs')
          .select('id, display_name, description, category, supported_sizes, supported_qualities, priority')
          .eq('is_active', true)
          .order('priority', { ascending: true })
          .order('category')
          .order('display_name');

        if (error) throw error;

        // Deduplicate models by display_name (in case same model exists across providers)
        const uniqueModels = data?.reduce((acc: PublicModel[], current) => {
          const exists = acc.find(model => model.display_name === current.display_name);
          if (!exists) {
            acc.push(current);
          }
          return acc;
        }, []) || [];

        setModels(uniqueModels);
      } catch (err) {
        console.error('Error fetching models:', err);
        setError('Failed to load models');
      } finally {
        setLoading(false);
      }
    };

    fetchModels();
  }, []);

  return { models, loading, error };
};
